import styled from 'styled-components';
export const Container = styled.div`
   display: flex;
   flex-direction: column;
   padding: 0.4rem;
   border-radius: 10px;
   box-shadow: 0 1px 1px #ccc;
   background-color: ${({ isUserSystem }) => isUserSystem ?' #E7F8FF' :'#ffffff'};

   > div:nth-child(1) {
      z-index: 9;
   }

   p{
      padding: 2px;
      font-size: 14px;
      word-break: break-word;
      white-space: pre-wrap; 
      text-align: left;
      margin-right: 30px;
   }

   .copy--token{
      display: flex;
      width: 100%;
      height: 45px;
      justify-content: center;
      align-items: center;
      border-top: solid 1px #999999;
   }
   button{
      display: flex;
      outline: none;
      border: none;
      width: 10rem;
      height: 2rem;
      font-weight: 800;
      padding: 0.5rem;
      gap: 5px;
      color: #999999;
      align-items: center;
      justify-content: center;
      border-radius: 6px;
      border: 1px solid #999999;
      cursor: pointer;
      background-color: transparent;
      &:hover{
         color: #1D86FF;
         border-color: #1D86FF;
      }
   }

`